export enum ExpenditureTypeEnum {
    overdraft = 'overdraft',
    creditCard = 'creditCard',
    consumerLoan = 'consumerLoan',
    mortgage = 'mortgage',
    buildingSavingsLoan = 'buildingSavingsLoan',
    alimony = 'alimony',
    nonbankLoan = 'nonbankLoan',
    leasing = 'leasing',
    businessLoan = 'businessLoan',
    other = 'other',
}
